import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/propertyAmenities/usePropertyAmenitiesQueryKeys.ts
var t = e("propertyAmenities", { list: (e) => e ? ["list", e] : ["list"] });
//#endregion
export { t as propertyAmenitiesQueryKeys };
